export default () => {
  const validateKioskUserName: (s?: string) => boolean = () => true as any;

  return { validateKioskUserName };
};
